@if (showField$ | async) {
  <div class="cs-wrapper">
    <h4>{{field.label | translate}}</h4>
    @if (field.help) {
      <mat-hint class="text-muted">{{field.help | translate}}</mat-hint>
    }
    @for (cb of field.fieldList; track cb) {
      <nuso-form-control [field]="cb"></nuso-form-control>
    }
    @if (hasDanger() && !isDisabled()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
  </div>
}
